var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-hour';
                    var viewUrl = 'sprite.svg#view-icon-hour';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 32 32',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };